import * as React from "react";
const SvgFiRrCardSpade = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16 13a2 2 0 0 1-3.425 1.401c.194.657.452 1.275.798 1.813.219.341-.003.785-.407.785h-1.931c-.405 0-.626-.445-.407-.785.346-.539.604-1.156.798-1.813A2 2 0 0 1 8.001 13c0-2.333 4-5 4-5S16 10.667 16 13m5-8v14c0 2.757-2.243 5-5 5H8c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h8c2.757 0 5 2.243 5 5m-2 0c0-1.654-1.346-3-3-3H8C6.346 2 5 3.346 5 5v14c0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3z"
    />
  </svg>
);
export default SvgFiRrCardSpade;
